import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { cva as p } from "class-variance-authority";
import { cn as l } from "../../utils/cn.js";
const N = p("bg-background-secondary flex items-center justify-between rounded-2xl px-4 py-3", {
  variants: {
    fullWidth: {
      true: "w-full",
      false: "w-auto"
    },
    gap: {
      true: "gap-4",
      false: "gap-2"
    }
  },
  defaultVariants: {
    fullWidth: !0,
    gap: !0
  }
}), j = ({
  leftIcon: d,
  leftIconClassName: x,
  leftTopText: n,
  leftBottomText: c,
  rightIcon: i,
  rightIconClassName: u,
  rightTopText: r,
  rightBottomText: t,
  withSeparator: f,
  fullWidth: m,
  gap: b,
  className: o,
  onClick: s,
  children: v
}) => /* @__PURE__ */ a(
  "div",
  {
    className: l(
      N({ fullWidth: m, gap: b }),
      f && "focus:bg-background-secondary/70 rounded-b-none border-b border-black/5 last:rounded-b-2xl last:border-b-0 focus:outline-none dark:border-white/5",
      o
    ),
    role: "button",
    tabIndex: 0,
    onClick: s,
    onKeyDown: (h) => {
      h.key === "Enter" && (s == null || s());
    },
    children: [
      /* @__PURE__ */ a("div", { className: "flex items-center gap-3", children: [
        !!d && /* @__PURE__ */ e("div", { className: l("flex-shrink-0", x), children: d }),
        /* @__PURE__ */ a("div", { className: "flex flex-col gap-0.5 text-left", children: [
          !!n && /* @__PURE__ */ e("span", { className: "text-text text-headline", children: n }),
          !!c && /* @__PURE__ */ e("span", { className: "text-text-secondary text-subhead", children: c })
        ] })
      ] }),
      /* @__PURE__ */ a("div", { className: "flex items-center gap-3", children: [
        (!!r || !!t) && /* @__PURE__ */ a("div", { className: "flex flex-col gap-0.5 text-right", children: [
          !!r && /* @__PURE__ */ e("span", { className: "text-text text-headline", children: r }),
          !!t && /* @__PURE__ */ e("span", { className: "text-text-secondary text-subhead", children: t })
        ] }),
        i && /* @__PURE__ */ e("div", { className: l("flex-shrink-0", u), children: i })
      ] })
    ]
  }
);
export {
  j as ListItem
};
//# sourceMappingURL=index.js.map
